module.exports = __webpack_public_path__ + "static/media/SE.fba03be2.svg";